import React, { useEffect, useState } from "react";
import {

  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  Skeleton
} from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { Helmet } from 'react-helmet-async';

import MyCustomUploadAdapterPlugin from './customEditor/customEditor';
import Scrollbar from '../components/scrollbar/Scrollbar';
import Iconify from '../components/iconify';
import { Api, UploadFile } from '../webservices';

const filter = createFilterOptions();

export default function Applications() {
  const navigate = useNavigate()
  const [tab, setTab] = useState("foxearch");
  const [applications, setApplications] = useState([]);
  const location = useLocation();
  const { row } = location.state || {};
  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [phoneCopy, setPhoneCopy] = useState(false);


  const [newSkill, setNewSkill] = useState([])

  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);
  const openResume = (resUrl) => {
    setOpenRes(resUrl)
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };
  const tablebg = 'rgba(82, 130, 190, 0.08)';
  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '50%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const styleClients1 = {
    height: '90%',
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };


  const optionsDate = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };


  // console.log("Job ID:<<<<<<==========>>>>", row);

  // const tabStatus = {
  //   0: "new",
  //   1: "NEW",
  //   2: "NEW",
  //   3: "NEW",
  //   4: "NEW",
  //   5: "NEW",
  //   6: "SHORTLISTED",
  //   7: "REJECTED",
  // };

  const [loading, setLoading] = useState('');

  const fetchApplications = async (tab) => {
    setLoading("")
    setApplications([])
    const token = localStorage.getItem("token");
    const body = {
      jobId: row?.jobId,
      // applicationStatus: tabStatus[tab].toLowerCase(),
      applicationStatus: tab,
    };
    Api("common/getAllAppliedCandidates", 'POST', body, token)

      .then((response) => {

        if (response.status === 200) {
          console.log("heelo shyamlal sharma ji ==>>>", response)
          if (response.data.data?.length > 0) {
            // toast.success(response.data.message)
            setApplications(response.data.data);
            setLoading("")
          } else {
            setLoading("No data found")

          }

        } else {

          toast.error(response.data.message)
          setLoading("No data found")

        }
      })
      .catch((err) => {
        // toast.error(err?.message || "Something went wrong!");
      });
    console.log("API Request: ", body);

  };

  const [endClientName, setEndClientName] = useState('')

  const updateStatus = async (id, status) => {
    const token = localStorage.getItem("token");

    const body = {
      applicationIds: id,
      applicationStatus: status,
    };

    Api("common/updateApplicationStatus", "POST", body, token)
      .then((res) => {

        if (res.status === 200) {
          toast.success(res.data.message);
          // refresh list
          if (tab === "foxearch") {
            fetchApplications("new");
          } else if (tab === "shortlisted") {
            fetchApplications("shortlisted");
          } else {
            fetchApplications("rejected");
          }

        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };

  //   const submitApplication = async (row) => {
  //     const token = localStorage.getItem("token");

  //     const body = {
  //       "resumeId": row?.resumeId?._id
  //     };

  //     Api("common/submitApplication", "POST", body, token)
  //       .then((res) => {

  //         if (res.status === 200) {
  //           console.log("res", res)

  //           // refresh list
  //           // fetchApplications();
  //           if(res.data.message === "Already submitted"){ 
  // toast.success(res.data.message);
  //           } else {
  //   navigate('/resumeDetail', {
  //             state: {
  //               endClientName,
  //               addedSkills: "", row: row?.resumeId, fTab: 'submitted',
  //               submitId: row?.resumeId?._id,
  //               jobId: row?.jobId,

  //               // ...((row.status === 'placement' || row.status === 'started') && { openModal: "editOrNot" })
  //             }
  //           })
  //           }

  //         } else {
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch(() => {
  //         toast.error("Something went wrong!");
  //       });
  //   };

  // useEffect(() => {
  //   fetchApplications();
  // }, [tab]);

  const submitApplication = async (row) => {
    navigate('/resumeDetail', {
      state: {
        endClientName,
        addedSkills: "", row: row?.resumeId, fTab: 'submitted',
        submitId: row?.resumeId?._id,
        jobId: row?.jobId,
        application: "submit"
      }
    })
  }

  useEffect(() => {
    fetchApplications("new")
    getTemplList();
  }, []);

  const [recipientEmail, setRecipientEmail] = useState();
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [ccEmail, setCcEmail] = useState([]);

  const [checkedItems, setCheckedItems] = useState({});

  const [bccEmail, setBccEmail] = useState([]);

  const allChecked = applications?.length > 0 && applications?.every(item => checkedItems[item._id]);

  const handleCheck = (itemId, email, name) => {
    const isChecked = !checkedItems[itemId];

    const formattedName = (name || "")
      .split(" ")
      .map(
        (word) =>
          word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      .join(" ");

    setBccEmail((prev) => {
      let updated;

      if (isChecked) {
        const alreadyExists = prev?.some((item) => item.email === email);
        if (!alreadyExists) {
          updated = [...prev, { name: formattedName, email }];
        } else {
          updated = prev;
        }
      } else {
        updated = prev.filter((item) => item.email !== email);
      }

      if (updated?.length > 0) {
        setRecipientEmail(updated[0]?.email);
      } else {
        setRecipientEmail("");
      }

      return updated;
    });

    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: isChecked,
    }));
  };

  const handleSelectAll = () => {
    if (allChecked) {

      setBccEmail([]);
      setRecipientEmail("");
    } else {

      const formattedEmails =
        applications?.map((item) => ({
          name: (item?.resumeId?.fullName || "")
            .split(" ")
            .map(
              (word) =>
                word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
            )
            .join(" "),
          email: item?.resumeId?.email || "",
        })) || [];

      setBccEmail(formattedEmails);

      if (formattedEmails?.length > 0) {
        setRecipientEmail(formattedEmails[0]?.email);
      }
    }

    const newCheckedItems = applications?.reduce((acc, item) => {
      acc[item._id] = !allChecked;
      return acc;
    }, {});
    setCheckedItems(newCheckedItems);
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (email) => {
    // setSelectedCandidateId(id);
    // setRecipientEmail(email)
    setModalOpen(true);
    // alert(`Selected Candidate ID: ${id}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [greeting, setGreeting] = useState('')

  const [base64, setBase64] = useState([])
  const [fileName, setFileName] = useState('')
  const [fileType, setFileType] = useState('')
  const [attachment, setAttachment] = useState('')

  const FileChange = (event) => {
    const file = event.target.files[0];
    // console.log("file---", event.target.files)
    if (file) {
      setFileName(file.name)
      setFileType(file.type)
      convertFileToBase64(file);
      uploadAttach(file)
    } else {
      toast.warn('No file selected!');
    }
  };

  const uploadAttach = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setAttachment(response.data.filePath)
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
      // console.log("base64",reader.result)
    };
    reader.readAsDataURL(file);
  };

  const sign = localStorage.getItem("sign");

  const [loadingSend, setLoadingSend] = useState(false)

  const sendBulkEmail = async () => {
    setLoadingSend(true)
    const body = {
      "subject": subject,
      "attachment": attachment,
      "fileName": fileName,
      "others":
        // [
        // {
        //   "name": "",
        //   "email": ""
        // }
        bccEmail,
      // ],
      "mailBody": emailBody
      //       "mailBody":`${emailBody}<br/>${sign?.replace(
      //     /<figure[^>]*>(.*?)<\/figure>/gi,
      //     (_, innerContent) => `<p>${innerContent}</p>`
      //   )
      // }`
    };
    const token = localStorage.getItem('token');
    Api(`email/send_bulk_mail`, 'POST', body, token)
      .then((response) => {
        // console.log('====rec ====', response);
        if (response.status === 200) {
          handleCloseModal()
          toast.success(response.data.message);
          setLoadingSend(false)
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const [tempList, setTempList] = useState([])

  const getTemplList = () => {
    const token = localStorage.getItem('token');
    // console.log("token ===>>>>> ",token)
    Api('email/getEmailTemplateList', 'GET', '', token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            //  console.log("hhh")

          } else {
            // console.log('data:', response.data.message);
          }
        }
        setTempList(response.data.result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting)
      setSubject(item.template[0].subject)
      setEmailBody(item.template[0].emailBody)
    }
  };

  const multipleStatusChange = (type) => {
    // setLoading(true)
    // applications?.forEach(item => {
    const selectedIds = Object.keys(checkedItems).filter(
      id => checkedItems[id]
    );

    if (selectedIds.length === 0) {
      toast.warn("Please select at least one application");
      return;
    }
    // if (checkedItems[item._id]) { 

    if (type === "reject") {
      updateStatus(selectedIds, "rejected")
    } else {
      updateStatus(selectedIds, "shortlisted")
    }
    // }

    // }); 
    setCheckedItems({})
  };

  return (

    <>
      <ToastContainer />

      <Iconify icon="ion:arrow-back" fontSize={25} sx={{
        cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem',
        fontWeight: '600', mr: 1, mt: -1
      }} onClick={() => navigate(-1)} />

      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>

        <Box sx={{}}>
          <Typography variant="h5" color="textSecondary">
            Applications
          </Typography>
        </Box>

        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ ml: 'auto', mb: 0.6 }}>
          <Button color="custom" variant="contained" size="small" onClick={() => handleSelectAll()}>
            {allChecked ? "Deselect All" : "Select All"}
          </Button>
          <Button color="custom" variant="contained" size="small"

            onClick={() => handleOpenModal(applications?.[0]?.resumeId?.email)}
          >
            Email
          </Button>

          <Button color="custom" variant="contained" size="small"
            onClick={() => multipleStatusChange("shortlist")}

          >
            Shortlist
          </Button>
          <Button color="custom" variant="contained" size="small"
            onClick={() => multipleStatusChange("reject")}
          >
            Reject
          </Button>
        </Stack>
      </Stack>

      {/* <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable"

       sx={{
  minHeight: 36,
  "& .MuiTabs-flexContainer": {
    alignItems: "flex-end",
  },
  "& .MuiTabs-indicator": {
    bottom: 0,
    height: 3,
    backgroundColor: "#3C6BA5",
  },
  "& .MuiTab-root": {
    minHeight: 36,
    paddingBottom: "1px",
    fontSize: "15px",     
    // fontWeight: 600,
    textTransform: "none", 
  },
  "& .MuiTab-root.Mui-selected": {
    // fontWeight: 600, 
  },
}}


      >
        <Tab label="Foxearch" />
        <Tab label="Indeed" disabled />
        <Tab label="Monster" disabled />
        <Tab label="CB" disabled />
        <Tab label="Dice" disabled />
        <Tab label="LinkedIn" disabled />
        <Tab label="Shortlisted" />
        <Tab label="Unqualified" />
      </Tabs> */}

      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          cursor: 'pointer',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'flex-start',
          mb: 0.5,
        }}
      >
        <Stack
          sx={[
            { flexDirection: 'row', alignItems: 'center' },
            tab === 'foxearch'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
          onClick={() => {
            fetchApplications("new")
            setTab('foxearch');
          }}
        >
          <Iconify icon="mdi:magnify" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Foxearch
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'indeed'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
        >
          <Iconify icon="simple-icons:indeed" fontSize={14} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Indeed
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'monster'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
        >
          <Iconify icon="simple-icons:monster" fontSize={10} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Monster
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'cb'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
        >
          <Iconify icon="mdi:briefcase-outline" fontSize={14} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            CB
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'dice'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
        >
          <Iconify icon="simple-icons:dice" fontSize={15} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Dice
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'linkedin'
              ? { borderBottom: 3, color: 'text.secondary' }
              : { color: 'text.textG' },
          ]}
        >
          <Iconify icon="mdi:linkedin" fontSize={16} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            LinkedIn
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'shortlisted'
              ? { borderBottom: 3, color: "green" }
              : { color: 'text.textG' },
          ]}
          onClick={() => {
            fetchApplications("shortlisted")
            setTab('shortlisted');
          }}
        >
          <Iconify icon="mdi:check-circle-outline" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Shortlisted
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'unqualified'
              ? { borderBottom: 3, color: "red" }
              : { color: 'text.textG' },
          ]}
          onClick={() => {
            fetchApplications("rejected")
            setTab('unqualified');
          }}
        >
          <Iconify icon="mdi:close-circle-outline" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Unqualified
          </Typography>
        </Stack>
      </Stack>

      <TableContainer component={Paper} sx={{ mt: 0.3 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">

          <TableHead  >
            <TableRow
              sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}
            >
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>Date</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%' }}>Detail</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15.5%' }}>Contact Details</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15.5%' }}>Skills</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>Visa & Terms</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '5%' }}> Actions</TableCell>

            </TableRow>
          </TableHead>

          <TableBody >
            {applications?.map((row, index) => (

              <TableRow key={row._id}
                sx={[
                  { background: index % 2 === 0 ? 'text.background' : tablebg },
                  { '&:last-child td, &:last-child th': { border: 0 } },
                  { '&:hover': { boxShadow: 5 } },

                ]}
              >

                <TableCell sx={{ verticalAlign: 'top' }}>
                  {/* <Stack sx={{ flexDirection: "row" }}> */}

                  <Stack sx={{ flexDirection: "column" }}>
                    <Typography sx={{}} >
                      Up - {" "}
                      {row.updatedAt ? (
                        <>
                          {new Date(row.updatedAt)?.toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric',
                          })}{" "}
                          {
                            (() => {
                              const date = new Date(row.updatedAt);
                              const hours = date.getHours().toString().padStart(2, '0');
                              const minutes = date.getMinutes().toString().padStart(2, '0');
                              return `${hours}:${minutes}`;
                            })()
                          }
                        </>
                      ) : (
                        " -"
                      )}
                    </Typography>
                    {/* <Typography>-</Typography> */}
                    <Typography sx={{}}>

                      Cr - {`${new Date(row.createdAt)?.toLocaleString('en-US', optionsDate)} 
                                     ${String(new Date(row?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(row?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                    </Typography>

                    <Stack
                      sx={{
                        flexDirection: "column",
                        // mt:-1,
                        // mr:-1,
                        // mb:-1.5,
                        p: 0,
                        ml: -1,
                        mb: -0.1,
                        mt: -0.1,
                        cursor: "pointer",
                      }}
                    >
                      <FormControlLabel
                        sx={{
                          m: 0,
                          p: 0,
                        }}
                        control={
                          <Checkbox
                            sx={{
                              p: 0.5,
                            }}
                            checked={!!checkedItems[row._id]}

                            onChange={() => handleCheck(row?._id, row?.resumeId?.email, row?.resumeId?.fullName)}
                          />
                        }
                        label=""
                      />

                    </Stack>
                  </Stack>
                  {/* </Stack> */}
                </TableCell>

                <TableCell sx={{ maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'top' }}>

                  <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>

                    <Typography
                      sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.secondary'}
                    >
                      {row?.resumeId?.fullName || row?.resumeId?.fullName || row?.fullName || '-'}
                    </Typography>

                    <Iconify
                      icon="devicon:linkedin"
                      color={'text.textG'}
                      // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}
                      sx={{
                        ml: 1, height: 18, width: 18,
                        cursor: 'pointer'
                        // opacity: row.linkedinUrl ? 1 : 0.5,
                      }}
                      hover
                      onClick={() =>
                        window.open(row?.resumeId?.linkedinUrl || row?.resumeId?.linkedinUrl || row?.linkedinUrl, '_blank')
                      }
                    // onClick={() => {
                    //   if (row.linkedinUrl) {
                    //     window.open(row.linkedinUrl, '_blank');
                    //   }
                    // }}
                    />


                    <Iconify
                      icon="cuida:document-text-outline"
                      color="#1E74B3"
                      sx={{
                        ml: 0.6, height: 18, width: 18,
                        cursor: 'pointer'
                      }}
                      hover
                      onClick={() => openResume(row.resumeId.
                        additionalResumes[0].resumeUrl)}

                    />

                  </Stack>

                  <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                    {row?.resumeId?.currentCompany ||
                      row?.resumeId?.currentCompany || row?.resumeId.currentCompany || "-"}


                  </Typography>
                  <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                    {row?.resumeId?.jobTitle ||
                      row?.resumeId?.jobTitle || row?.resumeId.jobTitle || "-"
                    }
                  </Typography>

                </TableCell>

                <TableCell sx={{ verticalAlign: 'top' }}>

                  {row?.resumeId?.phone ? (
                    <Stack sx={{ flexDirection: 'row' }}>
                      <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {
                          row?.resumeId.phone?.trim()
                            ? row?.resumeId.phone?.trim()
                              ?.replace(/\s+/g, '')
                              ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                                if (p1) {
                                  const countryCode = p1;
                                  const lastDigits = p2?.slice(-10);
                                  return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                                }
                                return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                              })
                            : ''
                        }
                      </Typography>
                      {row?.resumeId?.phone && (

                        <CopyToClipboard text=
                          {
                            row?.resumeId?.phone?.trim()
                              ? row?.resumeId?.phone?.trim()
                                ?.replace(/\s+/g, '')
                                ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                                  if (p1) {
                                    const countryCode = p1;
                                    const lastDigits = p2?.slice(-10);
                                    return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                                  }
                                  return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                                })
                              : ''
                          }
                          onCopy={() => setPhoneCopy(true)}
                        >
                          <Iconify
                            icon="radix-icons:copy"
                            color={phoneCopy ? 'text.secondary' : 'text.textG'}
                            sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                            hover
                          />
                        </CopyToClipboard>
                      )}
                    </Stack>
                  ) : (
                    <Typography>-</Typography>
                  )}

                  {row.resumeId.email ? (
                    <Stack sx={{ flexDirection: 'row' }}>
                      <Typography

                        sx={{ textTransform: 'lowercase', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
                      >
                        {row.resumeId.email}
                      </Typography>
                      {row.resumeId.email && (

                        <CopyToClipboard text={row.resumeId.email}
                          onCopy={() => setEmailCopy(true)}
                        >
                          <Iconify
                            icon="radix-icons:copy"
                            color={emailCopy ? 'text.secondary' : 'text.textG'}
                            sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                          />
                        </CopyToClipboard>
                      )}
                    </Stack>
                  ) : (
                    <Typography>-</Typography>
                  )}

                  <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <Typography >
                      {
                        (row?.resumeId?.city || row?.resumeId?.stateCode)
                          ? `${row?.resumeId?.city}, ${row?.resumeId?.stateCode}`
                          : (row?.resumeId?.city || row?.resumeId?.stateCode
                            ? `${row?.resumeId?.city}, ${row?.resumeId?.stateCode || '-'}`
                            : (row?.resumeId?.city || row?.resumeId?.stateCode
                              ? `${row?.resumeId?.city}, ${row?.resumeId?.stateCode || '-'}`
                              : '-')
                          )
                      }

                    </Typography>
                    {row?.resumeId.relocation === 'yes' ? (
                      <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                    ) : ''}
                  </Stack>

                </TableCell>

                <TableCell sx={{ width: 180, verticalAlign: 'top' }}>
                  {row?.resumeId?.skill || row?.resumeId?.skill || row?.resumeId?.skill && (row?.resumeId?.skill.length > 0 ||
                    row?.resumeId?.skill.length > 0 || row?.resumeId?.skill.length > 0) ? (
                    <Grid container sx={{ maxWidth: 170, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>

                      {(row?.resumeId?.skill || row?.resumeId?.skill || row?.resumeId?.skill)?.slice(0, 4).map((item, index, arr) => (
                        item && (
                          <Typography key={index} sx={{ display: 'inline' }}>
                            {item}
                            {index < arr.length - 1 && ' | '}
                          </Typography>
                        )
                      ))}
                    </Grid>
                  ) : (
                    <Typography>-</Typography>
                  )}

                  {/* {(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill)?.length > 0 ? ( */}
                  <Typography
                    sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}

                    onClick={() => {
                      handleOpens()

                      setNewSkill(row?.resumeId?.skill || row?.resumeId?.skill || row?.skill);

                    }}
                  >
                    view all
                  </Typography>

                </TableCell>

                <TableCell sx={{ width: 110, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'top' }}>
                  <>
                    <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                      <Typography sx={{ paddingRight: 1 }}>
                        {row?.resumeId?.visaType || '-'}
                      </Typography>
                      {row?.resumeId?.visaTransfer === "yes" ? (
                        <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
                      ) : null}
                    </Box>

                    <Typography sx={{}}>
                      {row?.resumeId?.expectedCompensation ? (
                        <>
                          ${row?.resumeId?.expectedCompensation}
                          {(
                            row?.resumeId?.chargeType === 'hourly'
                          ) ? '/Hour' : 'K'}
                        </>
                      ) : "-"}
                    </Typography>

                    <Typography sx={{ textTransform: "capitalize" }} >
                      {row?.resumeId?.taxTerm || '-'}
                    </Typography>
                  </>
                </TableCell>

                <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>

                  <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                    {/* <Iconify icon="ic:baseline-email" fontSize={10} /> */}

                    <Iconify icon="icon-park-solid:check-one" fontSize={8}/>
                    <Typography sx={{}} onClick={() => submitApplication(row)}
                      >Submit</Typography>

                  </Stack>

                  <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                    <Iconify icon="mdi:check-circle-outline" fontSize={8} />
                    <Typography sx={{}} onClick={() => updateStatus([row._id], "shortlisted")}>Shortlist</Typography>
                  </Stack>

                  <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                    <Iconify icon="mdi:close-circle-outline" fontSize={8} />
                    <Typography sx={{}} onClick={() => updateStatus([row._id], "rejected")}>Reject</Typography>
                  </Stack>

                </TableCell>
              </TableRow>

            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* {loading === "" ? (
        <Stack>
          {Array.from({ length: 15 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>

      ) :
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>
            {loading}

          </Typography>
        </Stack>
      } */}

      <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>

          <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
            Skills

          </Typography>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,


                flexWrap: 'wrap'
              }}
            >


              {/* {row.skill?.map((item, index) => ( */}
              {newSkill?.filter(item => item !== '' && item != null).map((item, index) => (

                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < newSkill.length - 1 && '|'}



                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mt: -2.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 'bold',
                flex: 1,
                mb: 1,
                mt: 1,
              }}
            >
              Resume
            </Typography>
            <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color="text.secondary" />
            </a>
          </Box>
          <Scrollbar
            sx={{
              height: '97%',
              Scrollbar: 'thin',
              border: '2px solid #3C6BA5',
              borderColor: 'text.secondary',
              borderRadius: 2,
            }}
          >
            <Stack sx={{ p: 1.5 }}>

              <Box sx={{ overflowX: 'auto', minWidth: '600px' }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Box>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  multiple
                  size="small"
                  id="tags-outlined"
                  value={bccEmail}
                  onChange={(event, newValue) => {
                    setBccEmail(newValue);
                  }}
                  options={[]}
                  getOptionLabel={(option) => option.email || option.title || ''}
                  isOptionEqualToValue={(option, value) => option.email === value.email}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const { inputValue } = params;

                    const isExisting = bccEmail.some((item) => item.email === inputValue);
                    if (inputValue !== '' && !isExisting) {
                      return [
                        ...options,
                        {
                          name: '',
                          email: inputValue,
                        },
                      ];
                    }

                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Others"
                      placeholder="Others"
                      multiline
                      rows={3}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          alignItems: 'flex-start',
                          '& textarea': {
                            textAlign: 'left',
                            paddingTop: '1px !important',
                          },
                        },
                      }}
                    />
                  )}
                />

              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"

                    onChange={(e) => handleTemplateSelect(e.target.value)}
                  >
                    {tempList?.map((item) => (
                      <MenuItem key={item?.id} value={item}>
                        {item?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "bodyDis" } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '12px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>

            </Grid>

            <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
                  Attachment:
                </Typography>
                <input
                  type="file"
                  onChange={FileChange}
                  style={{
                    marginLeft: '9px',
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>

                  <Typography>Hello {'{Name},'}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{

                    extraPlugins: [MyCustomUploadAdapterPlugin]
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>

              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                // onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
                onClick={() => sendBulkEmail()}>
                {/* Send */}
                {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
    </>

  );
}
